module.exports = __webpack_public_path__ + "img/gateway-banner-03.056c4103.jpg";